<template><div><h1 id="artikelmerkmal" tabindex="-1"><a class="header-anchor" href="#artikelmerkmal"><span>Artikelmerkmal</span></a></h1>
<p>Artikelmerkmal — Ein Merkmal, mit dem Artikel ausgezeichnet werden können</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der speziellen Kennzeichnung von Artikeln. Diese Kennzeichnungen können für Auswertungen verwendet werden, aber auch dafür, gewisse Aktionen des Systems in der Auftragserfassung auszulösen. Pro Artikel können mehrere Merkmale erfasst werden.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Merkmale</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>MeMa</dt>
<dd>Merkmalscode, 4-stellig, alphanumerisch</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Merkmals</dd>
<dt>Typ</dt>
<dd>Merkmalstyp. Löst Aktion im System aus:<br>&quot;leer&quot; = normales Merkmal ohne Aktion<br>W = Warnmerkmal, bei der Auftragserfassung erscheint eine Warnung mit dem Text, der in [Bezeichnung] eingegeben wurde<br>S = Sperrmerkmal, bei der Auftragserfassung erscheint ein Hinweis mit dem Text, der in [Bezeichnung] eingegeben wurde; das System verhindert eine Erfassung des Artikels</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


